<template>
  <div class="wrapper" v-bind="$attrs">
    <slot name="toggle" v-if="!!$slots.toggle || useDefaultToggle">
      <font-awesome-icon class="" :icon="toggleIcon()" />
    </slot>
    <transition :name="inverted ? 'slide-up' : 'slide-down'">
      <div v-if="isVisible" class="content-section">
        <slot>Default content to slide...</slot>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    inverted?: boolean;
    useDefaultToggle?: boolean;
  }>(),
  {
    inverted: false,
    name: "slide-down",
    useDefaultToggle: false,
    isVisible: false,
  }
);

const toggleIcon = () => {
  return props.isVisible
    ? "fa-solid fa-chevron-down"
    : "fa-solid fa-chevron-up";
};
</script>

<style scoped>
.content-section {
  overflow: hidden;
  transition: all 0.4s ease-out;
}

/* --- Slide Down Animations --- */
.slide-down-enter-from,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-20px);
}

.slide-down-enter-to,
.slide-down-leave-from {
  max-height: 200px; /* Adjust based on content */
  opacity: 1;
  transform: translateY(0);
}

/* --- Slide Up Animations --- */
.slide-up-enter-from,
.slide-up-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(20px);
}

.slide-up-enter-to,
.slide-up-leave-from {
  max-height: 200px;
  opacity: 1;
  transform: translateY(0);
}
</style>
